<template>
    <TotemLink
        color="teams-blue"
        size="medium"
        class="digital-classrooms-event__button-teams"
        :label="$t('DigitalClassrooms.join_teams_meeting')"
        target="_blank"
        :href="meetingUrl"
    />
</template>

<script>
    export default {
        name: 'totem-teams-button',
        props: {
            meetingUrl: String
        }
    }
</script>
